import React from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const AssignProgramDialog = ({
  open,
  onClose,
  programs = [],
  templates = [],
  selectedProgramId,
  onProgramChange,
  startDate,
  onStartDateChange,
  daySelections = {},
  onDayChange,
  onAssign,
  saving,
}) => {
  const selectedProgram = programs.find((p) => p.id === selectedProgramId);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Assign Program</DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth sx={{ mt: 1 }} size="small">
          <InputLabel>Program</InputLabel>
          <Select
            label="Program"
            value={selectedProgramId}
            onChange={(e) => onProgramChange(e.target.value)}
          >
            {programs.map((p) => (
              <MenuItem key={p.id} value={p.id}>
                {p.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <DatePicker
          label="Start Date"
          value={startDate}
          onChange={(newValue) => onStartDateChange(newValue)}
          slotProps={{
            textField: {
              size: "small",
              fullWidth: true,
              margin: "normal",
            },
          }}
        />

        {selectedProgram && (
          <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2 }}>
            {selectedProgram.weeks?.map((week, wIdx) => (
              <Box
                key={wIdx}
                sx={{ border: "1px solid #eee", p: 2, borderRadius: 1 }}
              >
                <Typography variant="subtitle2" sx={{ mb: 1 }}>
                  Week {wIdx + 1}
                </Typography>
                {week?.map((tid) => {
                  const tmpl = templates.find((t) => t.id === tid);
                  if (!tmpl) return null;
                  return (
                    <Box
                      key={tid}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: 2,
                        mb: 1,
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          flex: 1,
                          minWidth: 0,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={tmpl.name}
                      >
                        {tmpl.name}
                      </Typography>
                      <FormControl size="small" sx={{ minWidth: 140 }}>
                        <InputLabel>Day</InputLabel>
                        <Select
                          label="Day"
                          value={daySelections[tid] ?? 1}
                          onChange={(e) => onDayChange(tid, e.target.value)}
                        >
                          <MenuItem value={1}>Monday</MenuItem>
                          <MenuItem value={2}>Tuesday</MenuItem>
                          <MenuItem value={3}>Wednesday</MenuItem>
                          <MenuItem value={4}>Thursday</MenuItem>
                          <MenuItem value={5}>Friday</MenuItem>
                          <MenuItem value={6}>Saturday</MenuItem>
                          <MenuItem value={0}>Sunday</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>
                  );
                })}
              </Box>
            ))}
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <LoadingButton
          onClick={onAssign}
          loading={saving}
          variant="contained"
          disabled={!selectedProgramId || !startDate}
        >
          Assign
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AssignProgramDialog;
